// DS: i7.3
import React from 'react';
import IconWrap from '../../IconWrap';
const CenterImage = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20 19c.5522847 0 1 .4477153 1 1 0 .5128358-.3860402.9355072-.8833789.9932723L20 21H4c-.55228475 0-1-.4477153-1-1 0-.5128358.38604019-.9355072.88337887-.9932723L4 19h16zm0-12c.5128358 0 .9355072.38604019.9932723.88337887L21 8v8c0 .5128358-.3860402.9355072-.8833789.9932723L20 17H4c-.51283584 0-.93550716-.3860402-.99327227-.8833789L3 16V8c0-.51283584.38604019-.93550716.88337887-.99327227L4 7h16zm0-4c.5522847 0 1 .44771525 1 1 0 .51283584-.3860402.93550716-.8833789.99327227L20 5H4c-.55228475 0-1-.44771525-1-1 0-.51283584.38604019-.93550716.88337887-.99327227L4 3h16z"
    })));
};
CenterImage.displayName = 'CenterImage';
export default CenterImage;

//# sourceMappingURL=CenterImage.js.map